import { Box, Center, Flex, Spinner, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react'
import VariableApi from './TestMessage/VariableApi.js'

import Header from '../components/Header.js'
import usePagePermissions from '../hooks/usePagePermissions'
import ParserApi from './TestMessage/ParserApi.js'
import BoxWrapper from '../components/BoxWrapper/BoxWrapper.jsx'
import SubscriberAPI from './TestMessage/SubscriberAPI.jsx'
import FlowApi from './TestMessage/FlowApi.js'
import EmailApi from './TestMessage/EmailApi.js'
import { LuSend } from 'react-icons/lu';
import PageHeading from '../components/shared/PageHeading';

const TABS = [
	{ label: 'Variable API', slug: 'send-msg-variable', Component: VariableApi },
	{ label: 'Passthrough API', slug: 'send-msg-pass-through', Component: ParserApi },
	{ label: 'Mobile Subscriber API', slug: 'send-msg-subscriber', Component: SubscriberAPI },
	{ label: 'Send Flow API', slug: 'send-msg-flow', Component: FlowApi },
	{ label: 'Send Test Email', slug: 'send-msg-test-email', Component: EmailApi },
];

const NoAccessBox = () => (
	<Center h="200px">
		<Box textAlign="center">
			<Text fontSize="md" fontWeight="semibold" color="gray.700" mb={1}>
				No Access
			</Text>
			<Text fontSize="sm" color="gray.500">
				You don't have permission to view this section.
			</Text>
		</Box>
	</Center>
);

const SendMessage = ({ header }) => {
	const { loading, can } = usePagePermissions('send-message');
	const [tabIndex, setTabIndex] = useState(0);
	const [hasSetInitialTab, setHasSetInitialTab] = useState(false);

	const tabPermissions = TABS.map((tab) => can(tab.slug));
	const hasAnyTabAccess = tabPermissions.some(Boolean);

	// Shared width for the pill tab bar and every card below it, so they
	// always end at exactly the same edge.
	const CONTENT_WIDTH = "800px";

	// Open on the first tab the user is actually allowed to use, once
	// permissions resolve. Only runs once so manual tab clicks afterwards
	// aren't overridden.
	useEffect(() => {
		if (loading || hasSetInitialTab) return;
		const firstAllowed = tabPermissions.findIndex(Boolean);
		if (firstAllowed !== -1) setTabIndex(firstAllowed);
		setHasSetInitialTab(true);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [loading, hasSetInitialTab]);

	if (loading) {
		return (
			<>
				<Header />
				<BoxWrapper >
					<Flex justify="center" align="center" h="300px">
						<Spinner size="lg" />
					</Flex>
				</BoxWrapper>
			</>
		);
	}

	if (!hasAnyTabAccess) {
		return (
			<>
				<Header header={header} />
				<BoxWrapper>
					<Center h="400px">
						<Box textAlign="center">
							<Text fontSize="xl" fontWeight="semibold" color="gray.700" mb={2}>
								No Access
							</Text>
							<Text fontSize="sm" color="gray.500">
								You don't have permission to view this section.
							</Text>
						</Box>
					</Center>
				</BoxWrapper>
			</>
		);
	}

	return (
		<div>
			<Header header={header} />
			<BoxWrapper>
				<Box>
					<PageHeading icon={LuSend} title="Send Test Message" subtitle="Try each messaging API directly — pick a method below and send a real test message." mb={5} />
					<Tabs variant="unstyled" isLazy index={tabIndex} onChange={setTabIndex}>
						<TabList bg="#f1f5f9" p="1" borderRadius="full" gap={1} w={CONTENT_WIDTH} maxW="100%" overflowX="auto" overflowY="hidden">
							{TABS.map((tab, index) => (
								<Tab
									key={tab.slug}
									flex={1}
									px={4}
									py={1.5}
									borderRadius="full"
									fontSize="sm"
									fontWeight="500"
									color="gray.500"
									whiteSpace="nowrap"
									transition="all 0.15s"
									isDisabled={!tabPermissions[index]}
									_hover={{ color: 'gray.700' }}
									_selected={{ bg: 'white', color: 'gray.800', fontWeight: '600', boxShadow: 'sm' }}
								>
									{tab.label}
								</Tab>
							))}
						</TabList>

						<TabPanels>
							{TABS.map((tab, index) => {
								const Component = tab.Component;
								return (
									<TabPanel key={tab.slug} px={0} pt={5}>
										{tabPermissions[index] ? (
											<Box className="box-style-card" w={CONTENT_WIDTH} maxW="100%" bg="white">
												<Component />
											</Box>
										) : (
											<NoAccessBox />
										)}
									</TabPanel>
								);
							})}
						</TabPanels>
					</Tabs>
				</Box>

			</BoxWrapper>
		</div>
	)
}

export default SendMessage
